import React from 'react'
import classnames from 'classnames/bind'
import { ColorNames } from '../../../constants/colorVars'
import Icon, { IconProps } from '../icon'
import Text from '../text'
import CardContainer from '../cardContainer'
import styles from './styles.scss'

const cx = classnames.bind(styles)

interface CardIconTitleProps {
  elmId: string
  iconProps: IconProps
  title: string
  body: string | string[]
}

const CardIconTitle: React.FC<CardIconTitleProps> = ({
  elmId,
  iconProps,
  title,
  body,
}) => {
  return (
    <div className={cx('u-stretch')}>
      <CardContainer
        elmId={elmId}
        borderRadius='medium'
        padding='medium'
        dropShadow='medium'
      >
        <div className={cx('title-wrapper')}>
          <Icon
            className={cx('u-mr-2')}
            size='big'
            iconStyle='regular'
            name={iconProps.name}
            color={iconProps.color}
          />
          <Text size='huge' weight='heavy'>
            {title}
          </Text>
        </div>
        {(Array.isArray(body) ? body : [body]).map((paragraph, index) => (
          <Text
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={cx({ 'u-mt-2': index > 0 })}
            color={ColorNames.Gray}
          >
            {paragraph}
          </Text>
        ))}
      </CardContainer>
    </div>
  )
}

export default CardIconTitle
